import { render, staticRenderFns } from "./search-bar.vue?vue&type=template&id=16a78a50&scoped=true&"
import script from "./search-bar.vue?vue&type=script&lang=ts&"
export * from "./search-bar.vue?vue&type=script&lang=ts&"
import style0 from "./search-bar.vue?vue&type=style&index=0&id=16a78a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a78a50",
  null
  
)

export default component.exports